import * as ng from 'angular';
import {ArchiSmallServices} from '../../../services/archismall.service';
import {IListini, IProfile} from '../../interfaces/listini';

class CopiaProfiloModalController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    'ArchiSmallServices',
    '$timeout',
    '$uibModalStack',
    '$state'
  ];

  private close: any;
  private dismiss: any;

  constructor(
    private $scope: any,
    private $rootScope: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $timeout: ng.ITimeoutService,
    private $modalStack: ng.ui.bootstrap.IModalStackService,
    private $state: any
  ) {

    const listino = $scope.$parent.$resolve.listino as IListini;
    const profilo = $scope.$parent.$resolve.profilo as IProfile;
    $scope.profilo = profilo;

    $scope.listini = [];
    $scope.lp = {listino: undefined};

    ArchiSmallServices.getListini().then(res => {
      $scope.listini = (JSON.parse(JSON.stringify(res)) as IListini[]).filter(l => l._id !== listino._id).filter(l => l.profileList ? !l.profileList.some(p => p.code === profilo.code) : true);
    });


    $scope.ok = () => {
      $scope.messaggio = null;
      ($scope.lp.listino as IListini).profileList ? ($scope.lp.listino as IListini).profileList.push(profilo) : ($scope.lp.listino as IListini).profileList = [profilo];
      ArchiSmallServices.updateListino($scope.lp.listino).then(res => {
        this.close({$value: true});
      }).catch(err => {
        $scope.messaggio = `Errore durante la copia ${err.data.errorDescription}`;
        console.log(err);
      });

    };
    $scope.annulla = () => {
      this.close({$value: false});
    };
  }
}

export const CopiaProfiloModalComponent: ng.IComponentOptions = {
  template: require('./copia-profilo-modal.html'),
  controller: CopiaProfiloModalController,
  bindings: {
    close: '&',
    dismiss: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/copia-profilo-modal/copia-profilo-modal.ts